module.exports = __webpack_public_path__ + "img/st6.946b2724.png";